import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { TextAccent } from '../../../components';
import { Wrapper, Section, TestimonialWrapper } from './Testimonial.style';
import Testimonials from '../../../components/Testimonials';

/**
 * Work/Sesame: Testimonials section
 */
const Testimonial = () => {
  const data = useStaticQuery(graphql`
    query {
      avatar: file(relativePath: { eq: "yulia-buell.png" }) {
        childImageSharp {
          fixed(width: 75) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `);

  return (
    <Wrapper>
      <Section>
        <TestimonialWrapper>
          <Testimonials
            authorImage={data.avatar.childImageSharp.fixed}
            authorName="Yulia Buell"
            authorTitle="Director of Engineering"
            background="#fff"
          >
            <TextAccent withSpacing>
              I had the pleasure of working with Danijel for more than a year. He was an amazing teammate who cared
              deeply about the team and the product we were building. He consistently suggested improvements to our
              processes, went above and beyond to onboard and mentor new team members, and always strived to do his
              best.
            </TextAccent>
            <TextAccent withSpacing>
              After joining the mobile team, he quickly became the tech lead, taking ownership and mentorship
              responsibilities, assisting with project planning, and tackling the most challenging parts of the mobile
              app.
            </TextAccent>
          </Testimonials>
        </TestimonialWrapper>
      </Section>
    </Wrapper>
  );
};

export default Testimonial;
